export const formatDetailsWithSpace = (value: string | undefined) => {
  if (!value) {
    return value
  }
  if (value.length === 6) {
    return value.replace(/(.{3})/g, '$1 ').trim()
  }
  return value
}
